import type { GADataProps } from "@elements/GAData/GAData";
import type { MetaTagsProps } from "@elements/MetaTags/MetaTags";
import { KAKI_MAKAN_LANDING_PAGE } from "@src/app/config/kakiMakan";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function KakiMakanMetaData(): PageMetaDataValues {
  const level2 = "Kaki Makan";

  const gaData: GADataProps = {
    level2: level2.toLowerCase(),
    title: level2,
    section: level2,
    contentcat: "1",
    contenttype: "listing",
  };

  const metaTags: MetaTagsProps = {
    title: "Kaki Makan 2025: Restoran & Makanan Terbaik di Singapura",
    description:
      "Jelajahi Kaki Makan 2025 - ulasan restoran, senarai makanan viral, panduan hawker, resipi fusion & sajian sihat di Singapura. Temui tempat makan terkini & trend makanan 2025 sekarang!",
    slug: KAKI_MAKAN_LANDING_PAGE,
  };

  return {
    gaData,
    metaTags,
  };
}
